<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex flex-wrap align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-file-plus" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Add Record</h4>
              <small style="opacity: .8;">Record an encounter for an enrollee</small>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container mt-n3 pb-5">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card table-card shadow mb-4">
                <div class="card-header">
                  <!-- <strong class="h3">Add Employee</strong> -->
                </div>

                <div class="card-body">
                  <form @submit.prevent="AddRecord">
                    <!-- Telemedicine consultation this encounter belongs to -->
                    <div v-if="consultation" class="alert alert-info mb-4">
                      <strong><i class="fe fe-video mr-1"></i>Telemedicine consultation</strong> for {{ consultation.patient_name }}
                      ({{ consultation.patient_id_card }}) on {{ consultation.appointDate }}
                      <div class="small">Reason: {{ consultation.reason }}</div>
                      <div class="small" v-if="consultation.referring_provider">Sent by {{ consultation.referring_provider.agency_name }}</div>
                    </div>
                    <div class="form-row">
                      <div class="col-md-6">
                        <label class="info-label d-block mb-1" for="inputCity">Date of Hospital Visit</label>
                        <input required class="form-control" type="date" v-model="record.date_of_visit" />
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputCity">Treatment Type</label>
                        <select required class="form-control" v-model="record.treatment_type">
                          <option value="Primary">Primary Treatment</option>
                          <option value="Secondary">Secondary Treatment</option>
                        </select>
                      </div>
                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputCity">Reason for Visit</label>

                        <select class="form-control" v-model="record.reasonVisit" required>
                          <option value="Telemedicine Consultation">Telemedicine Consultation</option>
                          <option :value="reason" v-for="reason in reasons" :key="reason">
                            {{ reason }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputCity">Search Enrollee </label>
                        <input required type="text" class="form-control"
                          placeholder="Agency Number, First Name, Last name, " v-model="searchkey"
                          @change="searchIDCard" />
                        <p>{{ search_result.length }} enrollee(s) found</p>
                      </div>

                      <div class="form-group col-md-12">
                        <label class="info-label d-block mb-1" for="inputPassword4">Select Enrollee </label>
                        <!-- <v-select
                        v-model="selected_enrollee"
                        label="user_query"
                        :options="search_result"
                      /> -->

                        <select class="form-control" v-model="selected_enrollee" required
                        @change="getDrugs(); getServices()"
                        >
                          <option :value="user" v-for="user in search_result" :key="user.id">
                            {{ user.user_query }}
                          </option>
                        </select>
                      </div>

                      <div>
                        <div class="row col-md-12" v-show="userDetails">
                          <div class="col-md-6 offset-md-3 my-6">
                            <img :src="`https://claimify-api.hayokmedicare.ng/image/${selected_enrollee.user_image}`"
                              class="img" alt="User Photo"
                              onerror="this.onerror=null; this.src='/assets/img/zamchema_logo.png'" />
                          </div>
                          <div class="form-group col-md-4">
                            <label class="info-label d-block mb-1" for="inputCity">Enrollee Full Name </label>
                            <input type="text" class="form-control" :value="selected_enrollee.full_name" disabled />
                          </div>
                          <div class="form-group col-md-4">
                            <label class="info-label d-block mb-1" for="inputCity">Enrollee Gender</label>
                            <input type="text" class="form-control" :value="selected_enrollee.gender" disabled />
                          </div>

                          <div class="form-group col-md-4">
                            <label class="info-label d-block mb-1" for="inputCity">Sector </label>
                            <input type="text" class="form-control" id="inputEmail4" :value="selected_enrollee.sector"
                              disabled />
                          </div>

                          <div class="form-group col-md-4">
                            <label class="info-label d-block mb-1" for="inputCity">DOB </label>
                            <input type="text" class="form-control" id="inputEmail4" :value="selected_enrollee.dob"
                              disabled />
                          </div>
                          <div class="form-group col-md-4">
                            <label class="info-label d-block mb-1" for="inputCity">Phone Number</label>
                            <input v-phone required type="text" class="form-control" id="inputEmail4"
                              ref="enrolleePhone" v-model="selected_enrollee.phone_number" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-row">


                      <!-- Vital signs (same card as the other frontends; values in this.vital) -->
                      <div class="form-group col-md-12">
                        <div class="card shadow-sm mb-2" style="border: 1px solid #e9ecef;">
                          <div class="card-header border-0 pt-3 pb-3 px-4" style="background: #f8f9fa;">
                            <div class="d-flex align-items-center justify-content-between">
                              <div class="d-flex align-items-center">
                                <i class="fe fe-activity text-info mr-2"></i>
                                <h6 class="mb-0 font-weight-bold text-dark">Vital Signs</h6>
                              </div>
                              <button type="button" class="btn btn-sm"
                                :class="showVitals ? 'btn-outline-danger' : 'btn-outline-info'" @click="showVitals = !showVitals">
                                <i class="fe mr-1" :class="showVitals ? 'fe-minus' : 'fe-plus'"></i>
                                {{ showVitals ? 'Hide Vitals' : 'Add Vitals' }}
                              </button>
                            </div>
                          </div>
                          <div v-show="showVitals" class="card-body px-4 pt-3">
                            <!-- BP badge indicator -->
                            <div class="row mb-3">
                              <div class="col-12">
                                <small class="text-muted">Fill in the measurements taken at this visit. BMI is calculated
                                  automatically.</small>
                              </div>
                            </div>

                            <div class="form-row">
                              <!-- Temperature -->
                              <div class="form-group col-md-3 col-6">
                                <label class="small font-weight-bold text-secondary">Temperature (°C)</label>
                                <div class="input-group input-group-sm">
                                  <input type="number" step="0.1" min="30" max="45" class="form-control"
                                    v-model="vital.temperature" placeholder="36.5" />
                                  <div class="input-group-append"><span class="input-group-text">°C</span></div>
                                </div>
                              </div>

                              <!-- Pulse Rate -->
                              <div class="form-group col-md-3 col-6">
                                <label class="small font-weight-bold text-secondary">Pulse Rate (bpm)</label>
                                <div class="input-group input-group-sm">
                                  <input type="number" min="0" max="300" class="form-control" v-model="vital.pulse_rate"
                                    placeholder="72" />
                                  <div class="input-group-append"><span class="input-group-text">bpm</span></div>
                                </div>
                              </div>

                              <!-- Respiratory Rate -->
                              <div class="form-group col-md-3 col-6">
                                <label class="small font-weight-bold text-secondary">Respiratory Rate</label>
                                <div class="input-group input-group-sm">
                                  <input type="number" min="0" max="100" class="form-control" v-model="vital.respiratory_rate"
                                    placeholder="18" />
                                  <div class="input-group-append"><span class="input-group-text">/min</span></div>
                                </div>
                              </div>

                              <!-- Blood Glucose -->
                              <div class="form-group col-md-3 col-6">
                                <label class="small font-weight-bold text-secondary">Blood Glucose</label>
                                <div class="input-group input-group-sm">
                                  <input type="number" step="0.1" min="0" class="form-control" v-model="vital.blood_glucose"
                                    placeholder="5.5" />
                                  <div class="input-group-append"><span class="input-group-text">mmol/L</span></div>
                          </div>
                        </div>
                      </div>

                      <!-- Blood Pressure row with visual separator -->
                      <div class="p-3 rounded mb-3" style="background: #fff8e1; border: 1px solid #ffe082;">
                        <p class="small font-weight-bold text-warning mb-2"><i class="fe fe-activity mr-1"></i>Blood Pressure
                        </p>
                        <div class="form-row">
                          <div class="form-group col-md-6 mb-0">
                            <label class="small font-weight-bold text-secondary">Systolic (mmHg)</label>
                            <div class="input-group input-group-sm">
                              <input type="number" min="0" max="300" class="form-control" v-model="vital.systolic"
                                placeholder="120" />
                              <div class="input-group-append"><span class="input-group-text">mmHg</span></div>
                            </div>
                          </div>
                          <div class="form-group col-md-6 mb-0">
                            <label class="small font-weight-bold text-secondary">Diastolic (mmHg)</label>
                            <div class="input-group input-group-sm">
                              <input type="number" min="0" max="200" class="form-control" v-model="vital.diastolic"
                                placeholder="80" />
                              <div class="input-group-append"><span class="input-group-text">mmHg</span></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Anthropometrics row with BMI -->
                      <div class="p-3 rounded" style="background: #e8f5e9; border: 1px solid #a5d6a7;">
                        <p class="small font-weight-bold text-success mb-2"><i class="fe fe-user mr-1"></i>Anthropometrics</p>
                        <div class="form-row align-items-end">
                          <div class="form-group col-md-4 mb-0">
                            <label class="small font-weight-bold text-secondary">Weight (kg)</label>
                            <div class="input-group input-group-sm">
                              <input type="number" step="0.1" min="0" max="500" class="form-control" v-model="vital.weight"
                                placeholder="70" />
                              <div class="input-group-append"><span class="input-group-text">kg</span></div>
                            </div>
                          </div>
                          <div class="form-group col-md-4 mb-0">
                            <label class="small font-weight-bold text-secondary">Height (cm)</label>
                            <div class="input-group input-group-sm">
                              <input type="number" step="0.1" min="0" max="300" class="form-control" v-model="vital.height"
                                placeholder="170" />
                              <div class="input-group-append"><span class="input-group-text">cm</span></div>
                            </div>
                          </div>
                          <div class="form-group col-md-4 mb-0">
                            <label class="small font-weight-bold text-secondary">BMI <span
                                class="text-muted">(auto)</span></label>
                            <div class="input-group input-group-sm">
                              <input type="text" class="form-control font-weight-bold" :class="bmiClass"
                                :value="calculateBMI() || '—'" readonly style="background: #fff;" />
                              <div class="input-group-append">
                                <span class="input-group-text" :class="bmiClass">{{ bmiLabel }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-md-12">
                        <label class="info-label d-block mb-1" for="inputCity">Family History, Allergies & Others </label>
                        <textarea required class="form-control" rows="4" v-model="record.family_history"></textarea>
                      </div>


                      <div class="form-group col-md-12">
                        <label class="info-label d-block mb-1" for="inputCity">History Taking</label>
                        <textarea required class="form-control" rows="4" v-model="record.history_taking"></textarea>
                      </div>


                      <div class="form-group col-md-12">
                        <label class="info-label d-block mb-1" for="inputCity">Physical Examination</label>
                        <textarea required class="form-control" rows="4" v-model="record.examination"></textarea>
                      </div>



                      <div class="form-group col-md-12">
                        <label class="info-label d-block mb-1" for="inputCity">Consultation Notes</label>
                        <textarea required class="form-control" rows="4" v-model="record.medications"></textarea>
                      </div>


                      <div class="form-group col-md-4">
                        <label class="info-label d-block mb-1" for="inputPassword4">Main Diagnosis </label>
                        <v-select @input="clearOthers" v-model="record.diagnosis" label="name" :options="diseases" />
                      </div>

                      <div class="form-group col-md-4">
                        <label class="info-label d-block mb-1" for="inputPassword4">Other Diagnoses </label>
                        <v-select v-model="record.diagnoses" multiple :reduce="(name) => name.id" label="name"
                          :options="diseases" />
                      </div>

                      <div class="form-group col-md-4">
                        <label class="info-label d-block mb-1" for="inputCity">Encounter Outcome</label>
                        <select required class="form-control" v-model="record.encounter_outcome">
                          <option value="Admission">Admission</option>
                          <option value="Outpatient">Outpatient</option>
                          <option value="Referred Out">Referred Out</option>
                        </select>
                      </div>


                      <div v-if="record.treatment_type == 'Primary'">
                        <h3 class="h3">Investigations</h3>

                        <div v-for="(service_renderred, index) in record.investigations" v-bind:key="service_renderred"
                          class="card my-4">
                          <div class="row card-body">
                            <div class="form-group col-md-2" v-if="record.treatment_type == 'Primary'">
                              <label class="info-label d-block mb-1">Laboratory</label>
                              <select required class="form-control" v-model="service_renderred.type">
                                <!-- <option value="Drug">Drug</option> -->
                                <option value="Service" selected>Lab</option>
                              </select>
                            </div>

                            <div class="form-group col-md-5" v-if="
                          record.treatment_type == 'Primary' &&
                          service_renderred.type == 'Service'
                        ">
                              <label class="info-label d-block mb-1" for="inputPassword4">Select Investigation </label>
                              <v-select v-model="service_renderred.service" label="description"
                                :required="!record.services" :options="services.data" />
                            </div>

                            <div class="form-group col-md-4">
                              <label class="info-label d-block mb-1" for="inputCity">Result </label>
                              <input type="text" class="form-control" placeholder="Result"
                                v-model="service_renderred.result" />
                            </div>

                            <!-- <div class="form-group col-md-2">
                              <label class="info-label d-block mb-1" for="inputCity">Freq. </label>

                              <select class="form-control" v-model="service_renderred.frequency">
                                <option value="1">Daily</option>
                                <option value="2">BD</option>
                                <option value="3">TDS</option>
                                <option value="4">QDS</option>
                              </select>
                            </div> -->

                            <!-- <div class="form-group col-md-2">
                              <label class="info-label d-block mb-1" for="inputCity">Days </label>
                              <input type="number" min="1" class="form-control" required id="inputEmail4"
                                placeholder="1" v-model="service_renderred.days" />
                            </div> -->

                            <div class="col-md-6 my-2">
                              <button type="button" @click="addArrayLab()" class="btn btn-outline-success btn-block">
                                <i class="fe fe-plus"></i>
                              </button>
                            </div>

                            <div class="col-md-6 my-2">
                              <button type="button" @click="removeArrayLab(index)"
                                class="btn btn-outline-danger btn-block">
                                <i class="fe fe-delete"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>



                    </div>

                    <div v-if="record.treatment_type == 'Primary'">
                      <h3 class="h3">Treatment</h3>

                      <div v-for="(service_renderred, index) in record.services" v-bind:key="service_renderred"
                        class="card my-4">
                        <div class="row card-body">
                          <div class="form-group col-md-2" v-if="record.treatment_type == 'Primary'">
                            <label class="info-label d-block mb-1">Treatment </label>
                            <select required class="form-control" v-model="service_renderred.type">
                              <option value="Drug" selected>Drug</option>
                              <!-- <option value="Service">Investigation</option> -->
                            </select>
                          </div>

                          <div class="form-group col-md-4" v-if="
                          record.treatment_type == 'Primary' &&
                          service_renderred.type == 'Drug'
                        ">
                            <label class="info-label d-block mb-1" for="inputPassword4">Select Drug
                            </label>
                            <v-select v-model="service_renderred.drug" label="item_data" :required="!record.drugs"
                              :options="drugs.data" />
                          </div>

                          <div class="form-group col-md-4" v-if="
                          record.treatment_type == 'Primary' &&
                          service_renderred.type == 'Service'
                        ">
                            <label class="info-label d-block mb-1" for="inputPassword4">Select Investigation </label>
                            <v-select v-model="service_renderred.service" label="description"
                              :required="!record.services" :options="services.data" />
                          </div>

                          <div class="form-group col-md-2">
                            <label class="info-label d-block mb-1" for="inputCity">Dose </label>
                            <input type="number" min="1" class="form-control" required id="inputEmail4" placeholder="1"
                              v-model="service_renderred.dose" />
                          </div>

                          <div class="form-group col-md-2">
                            <label class="info-label d-block mb-1" for="inputCity">Freq. </label>

                            <select class="form-control" v-model="service_renderred.frequency">
                              <option value="1">Daily</option>
                              <option value="2">BD</option>
                              <option value="3">TDS</option>
                              <option value="4">QDS</option>
                            </select>
                          </div>

                          <div class="form-group col-md-2">
                            <label class="info-label d-block mb-1" for="inputCity">Days </label>
                            <input type="number" min="1" class="form-control" required id="inputEmail4" placeholder="1"
                              v-model="service_renderred.days" />
                          </div>

                          <div class="col-md-6 my-2">
                            <button type="button" @click="addArray()" class="btn btn-outline-success btn-block">
                              <i class="fe fe-plus"></i>
                            </button>
                          </div>

                          <div class="col-md-6 my-2">
                            <button type="button" @click="removeArray(index)" class="btn btn-outline-danger btn-block">
                              <i class="fe fe-delete"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-12">
                      <label class="info-label d-block mb-1" for="inputCity">Next Visit</label>
                      <input type="date" class="form-control form-control-sm" v-model="record.appointDate"
                        placeholder="Next Appointment" />
                    </div>

                    <div class="form-group mt-8" v-if="record.treatment_type == 'Primary'">
                      <button class="btn btn-submit btn-block" type="submit">
                        Submit <i class="fe fe-send"></i>
                      </button>
                    </div>

                    <div class="form-group mt-8" v-if="record.treatment_type == 'Secondary'">
                      <button class="btn btn-submit btn-block" type="submit">
                        Proceed to Claims <i class="fe fe-send"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
            </div>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  import reasonVisitList from "@/json/reasonVisit.json";


  export default {
    components: {
      Navbar,
      Loading,
      // DatePicker,
    },
    data() {
      return {
        user: null,
        // Telemedicine consultation (?appointment=ID): prefills the patient and links the encounter to it.
        consultation: null,
        searchkey: "",
        selected_enrollee: {},
        diseases: "",
        reasons: reasonVisitList,
        search_result: "",
        enrollee_details: "",
        edit: false,
        userDetails: false,
        isLoading: false,
        fullPage: true,
        clients: "",
        services: "",
        drugs: "",
        showVitals: true,
        vital: {
          temperature: "",
          pulse_rate: "",
          respiratory_rate: "",
          systolic: "",
          diastolic: "",
          weight: "",
          height: "",
          bmi: "",
          blood_glucose: "",
        },
        record: {
          provider_id: "",
          patient_id: "",
          reasonVisit: "",
          date_of_visit: "",
          appointDate: "",
          drVisited: "",
          testResult: "Not filled",
          documents: "no document uploaded",
          medications: "",
          notes: "Nil",
          family_history: "",
          history_taking: "",
          examination: "",
          patient_type: "",
          diagnosis: "",
          other_diagnosis: "",
          diagnoses: "",
          date_of_admission: "",
          date_of_discharge: "",
          treatment_type: "",
          encounter_outcome: "",
          services: [
            {
              drug: "",
              service: "",
              type: "Drug",
              dose: 1,
              frequency: 1,
              days: 1,
            },
          ],
          investigations: [
            {
              drug: "",
              service: "",
              type: "Service",
              dose: 1,
              frequency: 1,
              days: 1,
            },
          ],
          drug: "",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));

      if (this.$route.params.type == "secondary") {
        this.record.treatment_type = "Secondary";
      } else {
        this.record.treatment_type = "Primary";
      }
      this.axios
        .get(`/api/v1/auth/diagnosis-agency/95930`)
        .then((response) => {
          this.diseases = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    mounted() {
      if (this.$route.query.appointment) {
        this.loadConsultation(this.$route.query.appointment);
      }
    },
    computed: {
      bmiClass() {
        const bmi = parseFloat(this.calculateBMI());
        if (!bmi) return "text-muted";
        if (bmi < 18.5) return "text-info";
        if (bmi < 25) return "text-success";
        if (bmi < 30) return "text-warning";
        return "text-danger";
      },
      bmiLabel() {
        const bmi = parseFloat(this.calculateBMI());
        if (!bmi) return "—";
        if (bmi < 18.5) return "Underweight";
        if (bmi < 25) return "Normal";
        if (bmi < 30) return "Overweight";
        return "Obese";
      },
    },
    methods: {
      clearOthers() {
        this.record.other_diagnosis = "";
      },
      searchIDCard() {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/searchenrollees`, {
            // provider_id: this.user.institutional_id,
            agency_id: 4,
            request_query: this.searchkey,
          })
          .then((response) => {
            this.isLoading = false;
            this.search_result = response.data;
            this.selectConsultationPatient();

            this.userDetails = true;

            this.$toasted.info("Searched Successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      },

      loadConsultation(id) {

        this.axios

          .get(`/api/v1/auth/telemedicine/consultations/${id}`)

          .then((response) => {

            const c = response.data.data;

            if (!response.data.is_consulting_doctor) {

              this.$toasted.error("Only the telemedicine facility of this consultation can record its encounter.", { position: "top-center", duration: 5000 });

              return;

            }

            if (c.service_summary_id) {

              this.$router.replace(`/encounter/${c.service_summary_id}`);

              return;

            }

            this.consultation = c;

            this.record.reasonVisit = "Telemedicine Consultation";

            this.record.treatment_type = "Primary";

            this.searchkey = c.patient_id_card || "";

            if (this.searchkey) this.searchIDCard();

          })

          .catch(() => {

            this.$toasted.error("Could not load the telemedicine consultation.", { position: "top-center", duration: 4000 });

          });

      },


      // After a search, picks the consultation's patient (principal or dependant) from the results.

      selectConsultationPatient() {

        if (!this.consultation || !Array.isArray(this.search_result)) return;

        const c = this.consultation;

        const match = this.search_result.find((r) => (c.dependent_id

          ? r.type === "Dependent" && Number(r.id) === Number(c.dependent_id)

          : r.type === "client" && Number(r.id) === Number(c.patient_id)));

        if (match) this.selected_enrollee = match;

      },


      AddRecord() {
        this.user = JSON.parse(localStorage.getItem("user"));

        const combined = [...(this.record.services || []), ...(this.record.investigations || [])];

        // The enrollee's number on record is sent with the encounter; a wrong one is refused, so say so first.
        const phone = String((this.selected_enrollee && this.selected_enrollee.phone_number) || "").trim();
        if (phone && !/^\d{11}$/.test(phone)) {
          this.$toasted.error(`This enrollee's phone number on record ("${phone}") is not valid. Correct it in the phone field under the enrollee's name (11 digits, e.g. 08031234567) or clear it, then submit again.`, { position: "top-center", duration: 8000 });
          if (this.$refs.enrolleePhone) this.$refs.enrolleePhone.focus();
          return;
        }

        if (confirm("Are you Sure you want to Submit?")) {
          // Add comp
          this.isLoading = true;
          this.axios
            .post("/api/v1/auth/addHealthRecord", {
              // A facility account records for itself; facility staff for their facility.
              provider_id: this.user.type === "provider" ? this.user.id : this.user.institutional_id,
              appointment_id: this.consultation ? this.consultation.id : null,
              patient_id:
                this.selected_enrollee.type == "client"
                  ? this.selected_enrollee.id
                  : 0,
              dependent_id:
                this.selected_enrollee.type == "Dependent"
                  ? this.selected_enrollee.id
                  : null,
              reasonVisit: this.record.reasonVisit,
              testResult: this.investigationResults() || this.record.testResult,
              agency_id: 4,
              drVisited: this.user.id,
              professional_id: this.user.id,
              notes: this.record.medications,
              diagnosis: this.record.diagnosis.id,
              diagnoses: this.record.diagnoses,
              phone_number: this.selected_enrollee.phone_number,
              patient_type: this.record.patient_type,
              medications: "view service rendered page for more details",
              family_history: this.record.family_history,
              documents: this.record.documents,
              treatment_type: this.record.treatment_type,
              date_of_admission: this.record.date_of_admission,
              date_of_discharge: this.record.date_of_discharge,
              date_of_visit: this.record.date_of_visit,
              appointDate: this.record.appointDate,
              services: combined,
              history_taking: this.record.history_taking,
              examination: this.record.examination,
              //vitals
              temperature: this.vital.temperature,
              pulse_rate: this.vital.pulse_rate,
              respiratory_rate: this.vital.respiratory_rate,
              systolic: this.vital.systolic,
              diastolic: this.vital.diastolic,
              weight: this.vital.weight,
              height: this.vital.height,
              bmi: this.calculateBMI(),
              blood_glucose: this.vital.blood_glucose,
            })

            .then((response) => {
              console.log(response);
              this.clearIt();
              this.isLoading = false;
              this.$toasted.info("Added Successfully!", {
                position: "top-center",
                duration: 3000,
              });

              if (this.consultation) {

                // Back to the consultation: referral codes, claim (when the agency pays) and the record.

                this.$router.push(`/appointment/${this.consultation.id}`);

                return;

              }

              if (this.record.treatment_type == "Primary") {
                let record_id = response.data.service_summary.id;
                this.$router.push(`/encounter/${record_id}`);
              } else {
                let record_id = response.data.service_summary.id;
                this.$router.push(`/add-claim/${record_id}`);
              }
            })
            .catch((error) => {
              console.log(error.response);
              this.isLoading = false;
              this.$toasted.error((error.response && error.response.data && error.response.data.message) || "Submission failed. Please check all required fields.", {
                position: "top-center",
                duration: 8000,
              });
            });
        }
      },

      getDrugs() {
         let agency_id = (this.selected_enrollee && (this.selected_enrollee.sector === "Basic Healthcare Provision Fund" || this.selected_enrollee.sector === "UNICEF"))
          ? 1
          : 4;

        this.axios
          .get(`/api/v1/auth/drug-agency/${agency_id}`)
          .then((response) => {
            this.drugs = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getServices() {

        let agency_id = this.selected_enrollee.sector == "Basic Healthcare Provision Fund"
          ? 1
          : 4;
        this.axios
          .get(`/api/v1/auth/service-agency/${agency_id}`)
          .then((response) => {
            this.services = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      addArray() {
        this.record.services.push({
          drug: "",
          service: "",
          type: "Drug",
          dose: 1,
          frequency: 1,
          days: 1,
          total_cost: "1",
        });
      },

      addArrayLab() {
        this.record.investigations.push({
          drug: "",
          service: "",
          type: "Service",
          dose: 1,
          frequency: 1,
          days: 1,
          total_cost: "1",
        });
      },

      clearIt() {
        this.record.patient_id = "";
        this.record.drVisited = "";
        this.record.medications = "";
        this.record.reasonVisit = "";
        this.record.testResult = "";
      },

      removeArray(index) {
        if (this.record.services.length != 1) {
          // only splice array when item is found
          this.record.services.splice(index, 1); // 2nd parameter means remove one item only
        } else {
          this.$toasted.error("Minimum of 1 Service/Drug", {
            position: "top-center",
            duration: 3000,
          });
        }

        console.log(this.record.services);
      },


      removeArrayLab(index) {
        // if (this.record.investigations.length != 1) {
        // only splice array when item is found
        this.record.investigations.splice(index, 1); // 2nd parameter means remove one item only
        // }
        console.log(this.record.investigations);
      },

      // Height in cm, as on the other frontends.
      calculateBMI() {
        const w = parseFloat(this.vital.weight);
        const h = parseFloat(this.vital.height);
        if (w > 0 && h > 0) {
          const hm = h / 100;
          return (w / (hm * hm)).toFixed(1);
        }
        return "";
      },
      // "FBC: 12.5; Malaria parasite: positive" from the investigations with a result.
      investigationResults() {
        return (this.record.investigations || [])
          .filter((i) => i.service && String(i.result || "").trim() !== "")
          .map((i) => `${i.service.description || i.service.name || "Investigation"}: ${String(i.result).trim()}`)
          .join("; ");
      },

    },
    created() {
      // this.getDrugs();
      // this.getServices();
    },
  };
</script>